const state = {
  authenticating: false,
  accessToken: "",
  rules: [],
  authenticationErrorCode: 0,
  authenticationError: "",
  refreshTokenPromise: null, // Holds the promise of the refresh token
  UserInfo: {},
}

const getters = {
  loggedIn: (storeState) => {
    return !!storeState.accessToken
  },

  authenticationErrorCode: (storeState) => {
    return storeState.authenticationErrorCode
  },

  authenticationError: (storeState) => {
    return storeState.authenticationError
  },

  authenticating: (storeState) => {
    return storeState.authenticating
  },
}

const actions = {
  async signIn({ commit }, data) {
    try {
      commit("loginSuccess", data)
      router.push("/")
      return true
    } catch (e) {
      (e.message)
      if (e instanceof AuthenticationError) {
        commit("loginError", { errorCode: e.errorCode, errorMessage: e.message })
      }

      return false
    }
  },
  setOrganizationtype({ commit }, data) {
    commit("organizationtype", data)
  },
  logout({ commit }) {
    UserService.logout()
    commit("logoutSuccess")
    router.push("/login")
  },
  login({ commit }, data) {
    commit("loginSuccess", data)
  },
}

const mutations = {
  organizationtype(storeState, data) {
    storeState.organizationtype = data
  },
  loginRequest(storeState) {
    storeState.authenticating = true
    storeState.authenticationError = ""
    storeState.authenticationErrorCode = 0
  },
  setUserInfo(storeState, data) {
    storeState.UserInfo = data
  },

  loginSuccess(storeState, data) {
    storeState.accessToken = data.token
    storeState.permissions = data.userInfo.modules
    let formattedRules = []
    if (data.userInfo.modules.length > 0) {
      formattedRules = data.userInfo.modules.map((perm) => {
        const formattedObj = {}
        formattedObj.action = perm
        formattedObj.subject = "permissions"
        return formattedObj
      })
    }
    storeState.rules = formattedRules
    storeState.authenticating = false
  },
  logoutSuccess(storeState) {
    storeState.accessToken = ""
    storeState.UserInfo = {}
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
